import React from 'react';
import { LAUNCHER_STYLE_CSS } from '../../lib/embed/launcher-styles';
import { DEFAULT_EMBED_LABEL, type EmbedStyle } from '../../lib/embed/options';

/** A layout illustration that never creates a real response. */
export interface EmbedLauncherPreviewProps { style: EmbedStyle; label?: string; title?: string }

/** Show placement in a miniature website, with the chosen campaign and button copy. */
export const EmbedLauncherPreview: React.FC<EmbedLauncherPreviewProps> = ({ style, label, title }) => (
  <div className="overflow-hidden rounded-xl border border-border bg-background" aria-label={`${style === 'inline' ? 'Inline' : 'Popup'} layout preview`}>
    <style>{LAUNCHER_STYLE_CSS}</style>
    <div className="flex items-center gap-1.5 border-b border-border px-4 py-3" aria-hidden="true">
      {[0, 1, 2].map(dot => <span key={dot} className="h-1.5 w-1.5 rounded-full bg-subtle-foreground/40" />)}
      <span className="ml-auto text-xs text-muted-foreground">your website</span>
    </div>
    <div className="space-y-5 p-5 sm:p-6">
      <div aria-hidden="true" className="space-y-2">
        <div className="h-2.5 w-1/3 rounded-full bg-muted-foreground/25" />
        <div className="h-2 w-2/3 rounded-full bg-muted-foreground/10" />
      </div>
      {style === 'inline' ? (
        <div className="rounded-lg border border-border bg-surface p-5 space-y-4">
          <p className="text-sm font-semibold text-foreground truncate">{title || 'Your conversation'}</p>
          <div aria-hidden="true" className="space-y-3">
            <div className="h-2 w-3/4 rounded-full bg-muted-foreground/20" />
            <div className="h-10 rounded-lg border border-border bg-background" />
            <div className="ml-auto h-7 w-16 rounded-lg bg-volt" />
          </div>
        </div>
      ) : (
        <div className="flex min-h-32 items-center justify-center">
          <button type="button" tabIndex={-1} className={style === 'button' ? 'hollie-launcher-btn' : 'rounded-lg border border-border bg-surface px-5 py-3 text-sm font-semibold text-foreground'}>{label?.trim() || DEFAULT_EMBED_LABEL}</button>
        </div>
      )}
      <div aria-hidden="true" className="h-2 w-1/2 rounded-full bg-muted-foreground/10" />
    </div>
  </div>
);
